// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"1f5a6afc","338":"81954030","453":"612f53fa","516":"ceca7cea"}[chunkId] + ".chunk.js";
};